export default "__VITE_ASSET__DWoqGboB__"